import { observer } from 'mobx-react';
import _ from 'lodash';

import { ApiMixin } from "./ApiMixin";
import { EmployerApi } from '../../util/api/EmployerApi';

import { Alert } from "../Alert";

//Creates an object to represent the employer, with some helper functions
class Employer {
    id : "";
    name : "";
    city : "";
    state : "";
    country: "";

    supervisorIds: [];
    acccountIds: [];


    constructor(employer = {}, shouldParseValues = false) {
        //Adds any default values passed by the developer 
        _.defaults(this, employer);
    }

    mutate(employer = {}) {

        //This takes all matching keys from the employer and assigns them to this object

        _.assign(this, _.pick(employer, _.keys(this)));

    }


    //Saves/updates object to the api, shows errors or updates state. 
    async save(appStore) {

        const api = ApiMixin(EmployerApi);

        let response = await api.save(this);
        console.log(response)
        //If there are errors, we iterate over them and display them.
        //Then we return false, in case the parent needs to know we failed.

        if (response.errors.length > 0) {
            _.forEach(response.errors, (error) => {
                appStore.addAlert(error);
            });

            return response;
        }

        //If this already exists in the store, get it we'll be updating it both on api and in store.
        //We also need to check if it is the most recent payperiod (think about another way to do this.)
        let newEmployerObject;

        if (this.id) {

            let employerObject = appStore.employers.getById(this.id);

            //Diff any changes between store and response.
            employerObject.mutate(this);

            newEmployerObject = employerObject;
        }
        //If not, we're going to save it to the API, and to push it to the store
        else {

            newEmployerObject = new Employer(response.data);

            console.log(newEmployerObject)

            appStore.addItem({ type: "employer", data: newEmployerObject });
        }

        //Success alert
        let successAlert = new Alert("Successfully saved", "Successfully saved employer.", "sucess");
        appStore.addAlert(successAlert);


        //Return the new timesheet object  
        return newEmployerObject;
    }

}

export default Employer;